import React, { useEffect } from 'react';
import T from 'prop-types';
import { LoadingOutlined } from '@ant-design/icons';
import { Alert } from 'antd';

import ErrorAlert from '../errorAlert';
import Modal from '../modal';

const ConfirmationModal = ({
  activated,
  error,
  errorMessage,
  onOk,
  isLoading,
  isVisible,
  loadingMessage,
  name,
  okText,
  onLoad,
  successMessage,
  title,
  updateQueryString,
}) => {
  useEffect(() => {
    if (isVisible && !error && !isLoading && !activated) {
      onLoad();
    }
  });

  const handleOnCancel = () => {
    updateQueryString({
      modal: undefined,
      secret: undefined,
    });
  };

  let alert = <Alert icon={<LoadingOutlined />} message={loadingMessage} showIcon type="info" />;

  if (error) {
    alert = <ErrorAlert message={errorMessage} showIcon visible />;
  }

  if (activated) {
    alert = <Alert message={successMessage} showIcon type="success" />;
  }

  return (
    <Modal
      name={name}
      okButtonProps={{ disabled: isLoading }}
      okText={okText}
      onCancel={handleOnCancel}
      onOk={onOk}
      title={title}
    >
      {alert}
    </Modal>
  );
};

ConfirmationModal.defaultProps = {
  okText: 'Ok',
};

ConfirmationModal.propTypes = {
  onLoad: T.func.isRequired,
  onOk: T.func.isRequired,
  updateQueryString: T.func.isRequired,

  okText: T.string,
  title: T.string.isRequired,
  activated: T.bool.isRequired,
  error: T.bool.isRequired,
  errorMessage: T.string.isRequired,
  successMessage: T.string.isRequired,
  isVisible: T.bool.isRequired,
  isLoading: T.bool.isRequired,
  name: T.string.isRequired,
  loadingMessage: T.string.isRequired,
};

export default ConfirmationModal;
